// This file is auto-generated from an XLSX file

export enum LanguageEnum {
	'c2c3a9de-8a5b-4f0d-9d26-0e4b4e3a1001' = 'Abkhazian',
	'5a765850-67a6-4db0-8ca2-7ba976ab6c41' = 'Acholi (Acoli)',
	'8dc46505-2748-4fe6-844b-92e9bf680f89' = 'Afar',
	'9dfcea09-653d-40dd-ba2f-392b81d4d04a' = 'Afghani',
	'a8396f3c-b9e3-4637-b81c-74569c4a96d0' = 'Afrikaans',
	'8f0a7e22-3b6d-4fb4-8d9d-1c7c9b201002' = 'Aguacateco',
	'7783fbeb-51db-47a5-a96e-a2baabfc96b4' = 'Ahanti (Asante Twi)',
	'c7e44be1-7100-4f9d-b88a-cec0b7bf50a8' = 'Akan',
	'81d267a8-d222-4a3e-b472-911b0ce63f6d' = 'Akateko/Akateka',
	'74a6c47a-0e99-42a8-96ee-aff3e50db61d' = 'Albanian',
	'5b81f1a4-7c1e-4c90-bb8d-2d7e6f301003' = 'Aleut',
	'b1fd6776-b8d1-4f52-97c7-9108fc0cd682' = 'Algerian',
	'4594ef6d-6620-482f-abdc-04fc6c87e06f' = 'Alur',
	'8b7cda98-5389-4562-94e4-c6abd7cc5752' = 'American Sign Language (ASL)',
	'e0e31d26-4aab-4626-8785-a713226088cc' = 'Amharic',
	'5cc22b06-f4ad-434b-92ff-d49cfb2cd67f' = 'Anuak',
	'2e5dc4b7-9a82-45d0-90de-3f8b7a401004' = 'Apache',
	'a07b8dbc-6cf7-4347-9a8c-dd6913aea598' = 'Arabic',
	'7d96cb21-1f3c-46ba-9e3e-4b9c8d501005' = 'Arabic-Egyptian',
	'9b4f1a33-2d7a-4e81-b644-5ca9de601006' = 'Arabic-Iraqi',
	'1c8a7e44-3e9b-4af5-a8a1-6db0ef701007' = 'Arabic-Jordanian',
	'4d7b9f55-4af0-46d2-bd8b-7ec1fa801008' = 'Arabic-Levantine',
	'6e8c0a66-5bc1-4b31-ae52-8fd20b901009' = 'Arabic-Libyan',
	'7f9d1b77-6cd2-4cb4-9f73-90e31ca01010' = 'Arabic-Moroccan',
	'80ae2c88-7de3-4dc5-8b84-a1f42db11011' = 'Arabic-Palestinian',
	'91bf3d99-8ef4-4ed6-9c95-b2053ec21012' = 'Arabic-Saudi Arabian',
	'a2c04eaa-9f05-4fe7-ad06-c3164fd31013' = 'Arabic-Syrian',
	'b3d15fbb-a016-40f8-be17-d42750e41014' = 'Arabic-Tunisian',
	'c4e260cc-b127-4109-8f28-e53861f51015' = 'Arabic-Yemeni',
	'd5f371dd-c238-421a-9039-f64972061016' = 'Arapaho',
	'a04fd751-bb02-4e32-994b-cfbe34901318' = 'Armenian',
	'13aa1e33-06da-4168-892a-d067a274d301' = 'Ashanti',
	'e60482ee-d349-432b-a14a-075a83171017' = 'Assamese',
	'6a95dcef-511b-4af9-bd4a-2eea6212b7fa' = 'Assyrian',
	'0beb5e15-b628-4299-81d4-8bad3709a17f' = 'Ateso',
	'f71593ff-e45a-443c-b25b-186b94281018' = 'Awadhi',
	'0a26a500-f56b-454d-936c-297ca5391019' = 'Aymara',
	'1b37b611-067c-465e-a47d-3a8db64a1020' = 'Ayula-Bambara',
	'9c22c966-2456-4bb0-bcc5-26fda529f3dc' = 'Azerbaijani',
	'85c86964-74b6-48ca-8188-c6b907e8176a' = 'Azeri',
	'65633d12-fc60-4e61-a76d-27fe8130eb45' = 'Azorean Portuguese',
	'ab069cbb-0a88-4890-bd8d-1e641ee132f0' = 'Bahasa Indonesian',
	'29fd77fe-e64f-4726-a375-03f0c38c0179' = 'Bahnar',
	'2c48c722-178d-476f-b58e-4b9ec75b1021' = 'Balinese',
	'3d59d833-289e-4880-869f-5cad086c1022' = 'Balochi / Baluchi',
	'4e6ae944-39af-4991-97a0-6dbe197d1023' = 'Bamana',
	'2367d55f-0e48-4bbe-97ef-5dad3b540479' = 'Bambara - Mali',
	'00e2a1a0-db1d-4835-a63f-a0c296b50a2d' = 'Bangla',
	'5b9cc8d0-bdfe-4bf2-b508-ad12550695d4' = 'Bantu',
	'e171ee74-ccd8-4e2d-9bb3-12fc01e36935' = 'Bari',
	'0dea3bcf-c90c-49e4-8831-adfc2ed56ade' = 'Bashkir',
	'66882204-97b1-4aea-a30b-1d6479b42d30' = 'Basque',
	'11ff9035-dc4f-4eb5-9de4-7b52770b8c2c' = 'Bassa',
	'47ea1d52-c673-4ea5-8558-af723f1b6813' = 'Belarusan',
	'fe6c2d6e-7507-4bb0-9a78-06782dea5d18' = 'Bemba',
	'e09a0668-94a0-49c5-8e6c-3b39eebc4d79' = 'Bengali',
	'5f7bfa55-4ac0-4aa2-a8b1-7ecf2a8e1024' = 'Berber',
	'b54df014-b596-41e4-a777-bb2683da986b' = 'Bhutanese (Dzongkha)',
	'608c0b66-5bd1-4bb3-b9c2-8fe03b9f1025' = 'Bikol-Central',
	'719d1c77-6ce2-4cc4-cad3-90f14cb01026' = 'Bilen',
	'82ae2d88-7df3-4dd5-8be4-a2015dc11027' = 'Bisaya',
	'6b92a29a-c3fe-4290-8efa-1f6730ede4c0' = 'Bosnian',
	'926ecb44-553d-4479-b561-b9da8d507d0d' = 'Braille',
	'93bf3e99-8e04-4ee6-9cf5-b3126ed21028' = 'Bukusu',
	'37996bd4-39ec-4162-b5ff-7945446da29c' = 'Bulgarian',
	'a4c04faa-9f15-4ff7-ad06-c4237fe31029' = 'Buriat',
	'c2521484-487a-494a-95a5-1cf1f24766b0' = 'Burmese',
	'b5d160bb-a126-4008-be17-d53480f41030' = 'Byelorussian',
	'c6e271cc-b237-4119-8f28-e64591051031' = 'Cakchiquel',
	'6932e24c-96b1-4afd-9d92-b6407fb6c5a4' = 'Cambodian',
	'4a162f5d-4c2b-45e6-8016-97473f8d6d39' = 'Cambodian (Khmer)',
	'd7f382dd-c348-422a-9039-f756a2161032' = 'Cantonese',
	'544318fb-f206-42a5-9e08-852ccba83fd6' = 'Cape Verdean (Portuguese Creole)',
	'e80493ee-d459-433b-a14a-0867b3271033' = 'Carolinina',
	'bb0248f8-5cae-450c-be8a-788974a8ad48' = 'Catalan',
	'7c869fea-967a-4f88-9cc8-c8faef4a00b1' = 'Cebuano',
	'f915a4ff-e56a-444c-b25b-1978c4381034' = 'Chagatai',
	'0a26b510-f67b-455d-936c-2a89d5491035' = 'Chalchiteco',
	'78fd82b0-8954-433b-b5c5-e3e0dad78ddc' = 'Chaldean',
	'1b37c621-078c-466e-a47d-3b9ae65a1036' = 'Cham',
	'1f2146e1-05b2-43b0-ba6b-15b49161b075' = 'Chamorro',
	'2dfd73c6-1637-4bbd-9f85-a7aeffc4b824' = 'Chao-Chow',
	'126ad9a5-de25-4ca2-8559-8e27b933d0b0' = 'Chaozhou (Teochew)',
	'2c48d732-189d-477f-b58e-4cabf76b1037' = 'Chavacano',
	'3d59e843-29ae-4880-869f-5dbca87c1038' = 'Chechen',
	'4e6af954-3abf-4991-97a0-6ecdb98d1039' = 'Cheremis',
	'5f7c0a65-4bd0-4aa2-a8b1-7fdec99e1040' = 'Chewa',
	'dade64da-f203-45fd-aa96-55c3377f3bba' = 'Chin',
	'83886345-19d8-4acb-8ffe-9601178e6cf5' = 'Chin - Myanmar',
	'bfcf8c26-a53c-44d0-9cc5-a7080b51a750' = 'Chin (Zo, Zomi)',
	'0b615231-a61e-448f-9e59-1c280adecc66' = 'Chinese (Cantonese)',
	'257d480a-a42f-400c-af47-ff7c79271284' = 'Chinese (Mandarin)',
	'cfd903d5-8042-4e50-b1f3-6f909cda9f10' = 'Chinese (Simplified)',
	'9a2353ee-5b3c-4a5a-af75-f23a65d31015' = 'Chinese (Taishanese)',
	'2be21b70-40e2-4aa9-a5ed-c2f52b1cc149' = 'Chinese (Traditional)',
	'608d1b76-5ce1-4bb3-b9c2-80efdaaf1041' = 'Chinese:Fujianese',
	'719e2c87-6df2-4cc4-cad3-91f0ebc01042' = 'Chippewa',
	'a216c732-e059-4aae-bcbc-e525ef45c1cc' = 'Choujo',
	'6fcb940f-a629-4179-9541-99975aeb097f' = 'Chow Chou',
	'c975cc43-1bdb-40af-88ed-98ec29aeae15' = 'Chuj',
	'82af3d98-7e03-4dd5-8be4-a301fcd11043' = 'Chungki/Chunkese',
	'45691712-7021-45e6-82aa-1d6a8071e526' = 'Chuukese',
	'd73650d0-d63b-4e9a-8232-43fde44e4217' = 'Chuukese (Trukese)',
	'93c04ea9-8f14-4ee6-9cf5-b4120de21044' = 'Chuvash',
	'a4d15fba-9025-4ff7-ad06-c5231ef31045' = 'Columbia River Sehaptin',
	'b5e270cb-a136-4008-be17-d6342f041046' = 'Coptic',
	'c6f381dc-b247-4119-8f28-e74540151047' = 'Cornish',
	'e34120bd-37a8-41ba-b017-39b5da47b4d0' = 'Cotocoli (Tem)',
	'd70492ed-c358-422a-9039-f85651261048' = 'Cowichan',
	'64bde62f-fb19-46bb-bd75-46cd504de9d3' = 'Creole',
	'4fc08ae5-102b-428d-8722-56de18ea22bb' = 'Croatian',
	'e815a3fe-d469-433b-a14a-096762371049' = 'Crow',
	'b0db886a-bc26-4c93-8384-53a29fb3d959' = 'Czech',
	'f926b50f-e57a-444c-b25b-1a7873481050' = 'Dagbani',
	'f4cbf901-57b2-457e-be88-c8cdf68c9379' = 'Danish',
	'e4bd6a13-f6e5-40f3-8b96-45a35a08e585' = 'Dari',
	'31b0e622-8069-48e9-b006-8b7858a60178' = 'Dari (Afgan Farsi)',
	'03b432ef-d0c9-4135-8882-77f4956ea9d7' = 'Deaf Blind Tactile Interpreting',
	'aa6475ea-7c74-41ad-b7e9-a57f192c8682' = 'Dene - Canada',
	'250f68e4-4bae-4957-a2f2-88b80c95d393' = 'Dewoin',
	'0a37c620-f68b-455d-936c-2b8984591051' = 'Didinja',
	'1d642173-3180-43cc-b1b2-43a2b5506936' = 'Dinka',
	'1b48d731-079c-466e-a47d-3c9a956a1052' = 'Dire',
	'abf9b57a-4167-4a99-be70-38c7accd30df' = 'Duala',
	'2c59e842-18ad-477f-b58e-4dab067b1053' = 'Durcese',
	'0f3b015e-a636-460e-b2a0-dec545b3284f' = 'Dutch',
	'3d6af953-29be-4880-869f-5ebc178c1054' = 'Edo',
	'8f1c6b0b-1d02-40c9-85d5-0c1885bf6e3a' = 'Efik',
	'6a878217-8c3c-4d92-8878-5f10d3dc92a5' = 'Egyptian',
	'ed632db3-184c-4b07-b3ae-b58a933df525' = 'Embu',
	'2db19439-b440-4c31-aad4-190bca9b1a3f' = 'English',
	'f0feb318-c249-4039-9625-6821f023e13d' = 'English - Australian',
	'34e320e8-7b99-46c5-a745-9b85ddd3bbb2' = 'English (UK)',
	'02f418f8-eb5e-48d5-8814-58c77da57f6c' = 'English (US)',
	'4e7b0a64-3acf-4991-97a0-6fcd289d1055' = 'Eritai',
	'797fbb62-c65f-4cc7-bb51-06269bf3b7de' = 'Estonian',
	'5f8c1b75-4be0-4aa2-a8b1-80de39ae1056' = 'Ethiopic',
	'067f4bf8-3241-4c2c-adf2-b2cdb9c06a97' = 'Ewe',
	'609d2c86-5cf1-4bb3-b9c2-91ef4abf1057' = 'Fallani / Chaldean-Neo-Aramaic',
	'7436cdf7-3785-4c8f-bef4-6545385501a1' = 'Fante',
	'ad08d695-2653-458d-96d1-b76637b65176' = 'Fanti (Fante)',
	'1867ad6d-325d-4730-9878-a2215beb80df' = 'Farsi',
	'bd140e42-f0a4-4aab-9f18-608f9a85f8af' = 'Fiji',
	'1c554a41-d233-408c-9bf9-389457b7473d' = 'Filipino',
	'576ec02a-64b4-4d15-bbc5-8a05e45d956c' = 'Finnish',
	'0dedb77c-87df-4bfa-be4f-4e6c8d6afb2c' = 'Flemish',
	'71ae3d97-6d02-4cc4-cad3-a2f05bd01058' = 'FraFra',
	'0e7a1d70-4ed4-4cfb-8d22-d235c2782e31' = 'French',
	'cde31079-811e-43cd-9bde-3be38f5993b8' = 'French (Canada)',
	'a86a4dca-a6e0-45b4-a7ea-615c48dbe31a' = 'French Creole',
	'7cb7bb48-40fc-4a2a-b2e9-feb8e90afb15' = 'Fuchounese',
	'e11043ff-7ed7-4feb-b9bd-87eea1536cc3' = 'Fujian',
	'f574d936-8e24-453a-a58f-a121bdd261ec' = 'Fukienese',
	'82bf4ea8-7e13-4dd5-8be4-b3016ce11059' = 'Fulah / Fulfulde-Adamawa',
	'898a96b6-8ef7-4b62-b031-0ccc954c60f6' = 'Fulani',
	'c290afff-529b-4e24-9e7b-27f0928eca1c' = 'Fulde',
	'93d05fb9-8f24-4ee6-9cf5-c4127df21060' = 'Fulfulde',
	'a4e170ca-9035-4ff7-ad06-d5238e031061' = 'Fur',
	'c918371a-74da-4dc2-b298-d2adc8c1037d' = 'Fuzhou',
	'64c390c4-0679-45ed-8cd5-ca1e5c75be71' = 'Ga',
	'b5f281db-a146-4008-be17-e6349f141062' = 'Gaelic',
	'e248c1f9-fa1d-49d2-a539-4748dbb19058' = 'Galician',
	'c60392ec-b257-4119-8f28-f745a0251063' = 'Garifuna',
	'0a6be8be-d6af-4d43-a6da-dcbcfe6c0123' = 'Garre',
	'8a4c7cc4-9cbf-4d5f-a3ca-a1c9cdbcd0f7' = 'Gen (Mina)',
	'573d4a12-b542-415c-888b-df1d3629c275' = 'Georgian',
	'25628cf7-0bf3-4d02-b8b6-2fcbe67e7e95' = 'German',
	'd714a3fd-c368-422a-9039-0856b1361064' = 'Gilbertese',
	'a089c286-4831-4a85-b77c-57d81907c9f7' = 'Gisu (Lugisu)',
	'9349ccc1-af60-499a-a41e-2e0f4bd41e9d' = 'Gokana (Khana)',
	'e825b50e-d479-433b-a14a-1967c2471065' = 'Golo',
	'20ab2178-144d-43a4-85d3-7500edbbe99c' = 'Greek',
	'f936c61f-e58a-444c-b25b-2a78d3581066' = 'Greek, Modern',
	'0a47d730-f69b-455d-936c-3b89e4691067' = 'Gua',
	'b79a4514-2144-4a67-9b03-f91112b2e258' = 'Guarani',
	'0e2d88f9-3457-427f-90af-8c32abcc0df0' = 'Gujarati',
	'04f781fc-3496-4b50-abc8-2039731acb4e' = 'Gusii (Ekegusii/Kisii)',
	'1b58e841-07ac-466e-a47d-4c9af57a1068' = 'Haida',
	'd3404df9-6c6b-4f05-a412-2fd5027e1701' = 'Hainanese',
	'5b522bc7-a6cb-428b-b77b-8f70d0d46bbe' = 'Haitian',
	'd65eabac-708c-4815-a77a-af943e465a65' = 'Haitian Creole',
	'8dcdb72c-29b5-4e09-9614-533e61034c08' = 'Haka Bumese',
	'2e7e6dd8-1efd-412e-bcfc-c38b3bda1259' = 'Hakha Chin',
	'1bedd84c-0ed3-43b5-90fe-cd87470a0236' = 'Hakka',
	'3db1644c-2c1c-499e-93f6-dc38e05126a3' = 'Hassaniya',
	'd9593e75-b04e-4151-9211-b79ac8c6da95' = 'Hausa',
	'2c69f952-18bd-477f-b58e-5dab068b1069' = 'Hawaiian',
	'3d7b0a63-29ce-4880-869f-6ebc179c1070' = "Hawai'ian Creole",
	'62601570-a226-4d77-9ca8-5d1bd22fbfe5' = 'Hebrew',
	'4e8c1b74-3adf-4991-97a0-7fcd28ad1071' = 'Herero / Otjiherero',
	'9bb26d49-548c-4601-b5d2-787c005dac9b' = 'Hindi',
	'a1c2cf4d-12df-4539-b27c-9e6463b07c13' = 'Hmong',
	'5f9d2c85-4bf0-4aa2-a8b1-90de39be1072' = 'Hoh',
	'60ae3d96-5c01-4bb3-b9c2-a1ef4acf1073' = 'Hopi',
	'afe447f5-c553-4591-b17a-171185f6cee2' = 'Hungarian',
	'71bf4ea7-6d12-4cc4-cad3-b2f05bd01074' = 'Ibanag',
	'cfda3fe3-2495-44de-9697-eefd85318570' = 'Ibo (Igbo)',
	'1260d8a9-6910-4827-9594-8959dec2ef1e' = 'Icelandic',
	'82d05fb8-7e23-4dd5-8be4-c3016ce11075' = 'Icelandic (Old)',
	'8cd02bd9-f9e4-419b-bde9-3e00c680ec33' = 'Igbo',
	'179480b2-f242-4387-9c3a-391cf9318df6' = 'Ilocano',
	'705a44e4-8a65-474d-b57a-0faa47cdb0ab' = 'Ilonggo',
	'f28dc149-350f-4415-9343-9fcbd3e0c04c' = 'Indigenous - Latin America',
	'df7ef064-c365-4005-a4ec-7db39f16d40e' = 'Indonesian',
	'93e170c9-8f34-4ee6-9cf5-d4127df21076' = 'Inuktitut',
	'a4f281da-9045-4ff7-ad06-e5238e031077' = 'Inupiaq',
	'062de6e8-cc65-41cb-bfb7-caf9da5279f5' = 'Irish',
	'b50392eb-a156-4008-be17-f6349f141078' = 'Irula',
	'32d76a50-7bfa-4879-8bd8-6158ac475977' = 'Italian',
	'c614a3fc-b267-4119-8f28-0754a0251079' = 'Jamaican Creole',
	'd725b50d-c378-422a-9039-1865b1361080' = 'Jamaican Creole English',
	'e9580144-071c-451d-bb52-369b17035f98' = 'Japanese',
	'105a35df-8fc4-4d19-b97b-a84c9956b4db' = 'Jarai',
	'23085fcd-99cd-432d-b3bf-5f8cbc92f316' = 'Javanese',
	'17a1f079-791a-469b-872f-4808913e867e' = 'Jiangsu',
	'e836c61e-d489-433b-a14a-2976c2471081' = 'Jola-Fonyi',
	'f947d72f-e59a-444c-b25b-3a87d3581082' = 'Judezmo',
	'431cdbd0-18ff-45ea-a0c9-cfd88e6718fa' = 'Kachin',
	'0a58e840-f6ab-455d-936c-4b98e4691083' = 'Kakwa',
	'39b39dd9-1669-435f-864c-e00bf85474b1' = 'Kalenjin',
	'dd363f46-0e49-461b-93a5-f15eb9fad29c' = 'Kamba',
	'9aed5374-e709-4369-b2e8-52200597e48f' = "Kanjobal (Q'anjob'al)",
	'1b69f951-07bc-466e-a47d-5ca9f57a1084' = 'Kankanaey',
	'0fb7fa00-c2fb-4a55-b28e-ce03e7e33274' = 'Kannada',
	'3c17ac2c-b75d-4ad7-93a3-34ca46c0c773' = 'Kapampangan',
	'4f7fbecb-38eb-402c-a645-cce86c04639d' = 'Karen',
	'aecd5ff6-b1bd-45e8-8a93-250fbbedf1ca' = 'Karenni',
	'2c7b0a62-18cd-477f-b58e-6dba068b1085' = 'Karon',
	'3d8c1b73-29de-4880-869f-7ecb179c1086' = 'Kashmiri',
	'ae25fe46-cd72-43a7-b967-05353c000440' = 'Kayah',
	'4e9d2c84-3aef-4991-97a0-8fdc28ad1087' = 'Kayapo',
	'8bb38f41-7524-4dfc-aa09-e9771b003f7d' = 'Kazakh',
	'5fae3d95-4b00-4aa2-a8b1-90ed39be1088' = 'Khalkha',
	'52a16c5e-54f9-40b0-bef5-b8ede3887e9f' = 'Khmer',
	'deb110da-f8ba-44e5-a9ae-3558f06cd77d' = 'Kibajuni(Bajuni)',
	'b84fff33-5bb9-4241-84fb-861543c53523' = "K'iche' (Quiche)",
	'60bf4ea6-5c11-4bb3-b9c2-a1fe4acf1089' = "K'iche' use",
	'cad2149a-ac1c-4717-8c10-77fd9843af0d' = 'Kiga',
	'71d05fb7-6d22-4cc4-cad3-b20f5bd01090' = 'Kikamba',
	'a44715a7-9495-4a59-a0bf-0198a7e5ccc5' = 'Kikongo',
	'fe94315d-6f92-4ff8-9c5f-daee9ce3044a' = 'Kikuyu',
	'f683afc0-8e46-4768-92a3-a5fbf702f174' = 'Kinyamulenge',
	'21a9d9b2-9522-4752-9224-b7cf9d393a8f' = 'Kinyarwanda',
	'82e170c8-7e33-4dd5-8be4-c3216ce11091' = 'Kirgiz',
	'93f281d9-8f44-4ee6-9cf5-d4327df21092' = 'Kiribati',
	'137126bb-eaae-4c4f-95ea-9cfe2b255c6e' = 'Kirundi',
	'a40392ea-9055-4ff7-ad06-e5438e031093' = 'Kishinau',
	'f9647f43-45e7-42b3-8436-f317f7d16368' = 'Kiswahili',
	'd2b9861f-89ff-4f64-a311-20b1e683d3fb' = 'Kituba',
	'c625b50c-b277-4119-8f28-0765a0251095' = 'Kmhmu',
	'd3e9d64b-23c5-4c53-b763-6402b0227602' = 'Koho',
	'd736c61d-c388-422a-9039-1876b1361096' = 'Konkani',
	'5ed7ece8-f51c-47d7-80a9-9951e7dafdbd' = 'Korean',
	'2569522a-dfe5-45d9-b91f-baf726543ab9' = 'Kosraean',
	'2c55f8d5-f939-4512-b34a-fc631ebc860c' = 'Kpele',
	'916f0588-6e8b-4f02-a6b7-03e1c4442871' = 'Krahn',
	'ddb7a1c9-fac2-4f5c-847d-e5544830d19f' = 'Krio',
	'a8a53400-1fe0-4038-97c1-9ffc10351388' = 'Kuawaiti',
	'e847d72e-d499-433b-a14a-2987c2471097' = 'Kumeyaay',
	'90668c05-9ce0-447c-b5fc-d65b3dc0ff25' = 'Kunama',
	'd6acb0a2-73b3-4988-852c-2cc5023295c8' = 'Kurdish',
	'f958e83f-e5aa-444c-b25b-3a98d3581098' = 'Kurdish-Sorani',
	'59e195db-2933-4245-9bb3-7e6efc59976a' = 'Kurmanji',
	'5a80059f-abd3-4eed-976d-82d920fa4ffe' = 'Kyrgyz',
	'0a69f950-f6bb-455d-936c-4ba9e4691099' = 'Lakota',
	'9cf5f8cb-d873-4e86-89cb-69601968b201' = 'Lango',
	'c4c7c8f5-54f8-4fcd-8cbc-720a59938bb0' = 'Lao',
	'1b7b0a61-07cc-466e-a47d-5cba057a1100' = 'Lapp',
	'3735b958-c56d-4def-94ff-38b8f87901d7' = 'Latin',
	'45eca50d-4d98-4917-8202-c90b54872e7b' = 'Latvian',
	'869b0d52-fe70-4720-beb3-9d71b73776a8' = 'Lautu',
	'd7913cf5-1608-49b4-bebf-b503b080c854' = 'Lebanese',
	'd49d5677-8466-4f8f-8115-a1d5a44ff89c' = 'Lingala',
	'2c8c1b72-18dd-477f-b58e-6dcb168b1101' = "Lisan ud-Da'wat",
	'a5430f7f-8366-46ef-af08-930918dc6bbe' = 'Lithuanian',
	'a980cc10-b9f1-4778-a392-27c580a7115a' = 'Lorma',
	'3d9d2c83-29ee-4880-869f-7edc279c1102' = 'Luchuan',
	'4943a69a-0937-45cf-8369-5155c49841e4' = 'Luganda',
	'6614e1e2-27a6-4a0f-abee-2273672649e6' = 'Lugwere (Gwere)',
	'75581ee7-52e7-4042-a173-55444953acc9' = 'Luhya',
	'48e82dc1-3026-42c5-9109-f270802d7b25' = 'Luo',
	'1a0f80dc-4127-4970-bd4f-1796464c492f' = 'Lusoga (Soga)',
	'8ff56c18-edcf-4118-bbbf-cdfffe6ce56b' = 'Maasai (Maa)',
	'98b69d39-8c4e-4541-a9c3-25e01225b8db' = 'Maay-Maay',
	'd2501282-651f-4349-beb0-42895fe3220e' = 'Macedonian',
	'48c63fba-a7d2-4bd0-a1ab-49f1029580fa' = 'Maithili',
	'4eae3d94-3aff-4991-97a0-8fed38ad1103' = 'Makah',
	'5fbf4ea5-4b10-4aa2-a8b1-90fe49be1104' = 'Makonde',
	'60d05fb6-5c21-4bb3-b9c2-a10f5acf1105' = 'Makua',
	'904cdfa4-1a28-4ed1-bdd7-fd25cc82a356' = 'Malagasy',
	'98a24fe0-81ce-4380-821c-d6f4d75b17d3' = 'Malay',
	'92515f47-3978-4bdf-ba5f-ffffae2d2a21' = 'Malayalam',
	'133ac696-188a-4982-9351-84f218f6710c' = 'Malaysian',
	'c9879de9-671c-4461-8224-080b8b2d45eb' = 'Malinke',
	'44e3ab1e-96f1-44a9-a92a-37fd270d25ce' = 'Maltese',
	'6942808f-b0bc-42d4-9112-e5b063aec1e0' = 'Mam',
	'71e170c7-6d32-4cc4-cad3-b21f6bd01106' = 'Manchu',
	'82f281d8-7e43-4dd5-8be4-c3207ce11107' = 'Mandingo',
	'8acae6ee-7e75-4da6-8cb2-69a3e4ca9f70' = 'Mandinka (Mandingo)',
	'930392e9-8f54-4ee6-9cf5-d4318df21108' = 'Mano',
	'73fff926-5e71-48ad-aff5-65f3403f12b0' = 'Maori',
	'81d24ec2-044a-4f9e-9a1c-7332ed025e7f' = 'Mara',
	'67bb0085-48b5-49b3-a3ee-6b75cf641e6d' = 'Marathi',
	'a414a3fa-9065-4ff7-ad06-e5429e031109' = 'Mari-Eastern (formerly Cheremis)',
	'b525b50b-a176-4008-be17-f653af141110' = 'Marka',
	'c636c61c-b287-4119-8f28-0764c0251111' = 'Marquesan',
	'a66dba08-62a9-41db-8211-ac02727234aa' = 'Marshallese',
	'8c709623-f769-4a79-b4b6-a185473f06a6' = 'Matu',
	'c3fe438a-2e59-4691-a07d-c06cf34ffadc' = 'May May',
	'20f03669-19a5-48f3-9a8a-55d04381c83e' = 'Mayan',
	'cbbdd8bf-a3ad-455f-bd2b-7a1c92768a16' = 'Mayan - Yucateco',
	'7deb76d3-ac37-4b62-b07e-9bd798170b58' = 'Maya-Quiché',
	'5d997111-b45f-44b1-931a-94d7593ee8cd' = 'Mbay',
	'5a6062f6-f65b-4905-aa17-c938b6fa5270' = 'Mende',
	'bcbfd429-a0d7-4b8e-ba11-8eba9370de17' = 'Meru',
	'd747d72d-c398-422a-9039-1875d1361112' = 'Michif',
	'f733d3ca-8ff8-4e01-950f-76cc9ed9427e' = 'Mien',
	'e858e83e-d4a9-433b-a14a-2986e2471113' = 'Min Nan',
	'2d3a560a-c1c8-471c-8b74-a2fdb2140ee1' = 'Mina (Gen)',
	'5419fa34-0278-42db-8364-e456fe1438c2' = 'Minangkabau',
	'1044a781-c22c-4bbb-b95f-53d012bae46a' = 'Mixteco',
	'66c19812-3253-46c2-bd03-da4fafb8cceb' = 'Mixteco Alto',
	'6fcc5068-045f-43f7-9855-6345c16e4278' = 'Mixteco Bajo',
	'f969f94f-e5ba-444c-b25b-3a97f3581114' = 'Mizo',
	'0a7b0a60-f6cb-455d-936c-4ba805691115' = 'Mlabri',
	'649bc8ca-4365-40d1-8f4e-16f35201f4da' = 'Mnong',
	'1b8c1b71-07dc-466e-a47d-5cb9167a1116' = 'Mokilese',
	'241bb0a6-728a-4021-aece-d2fe464382bb' = 'Moldovan',
	'868fd2a4-6f4d-4eff-86df-64bd986879ae' = 'Mongolian',
	'4416c7ae-b65f-428f-b0db-e255f312a3bd' = 'Montenegrin',
	'2c9d2c82-18ed-477f-b58e-6dca278b1117' = 'Mordvin',
	'49584f0b-7859-46c5-af7d-83aeac869265' = 'More',
	'3dae3d93-29fe-4880-869f-7edb389c1118' = 'Mortlockese',
	'4ebf4ea4-3a0f-4991-97a0-8fec49ad1119' = 'Muckleshoot',
	'5fd05fb5-4b20-4aa2-a8b1-90fd5abe1120' = 'Mundu',
	'18b71a9c-7fa3-47dd-bb51-e9da3a196639' = 'Nahuatl',
	'60e170c6-5c31-4bb3-b9c2-a10e6bcf1121' = 'Nanai',
	'71f281d7-6d42-4cc4-cad3-b21f7cd01122' = 'Nauyat',
	'e358c716-26d2-46ab-a038-58cc8d277f12' = 'Navajo',
	'820392e8-7e53-4dd5-8be4-c3208de11123' = 'Ndebele',
	'af78f3dc-0eab-4cd4-a4ab-2c7cdfbb8160' = 'Nepali',
	'68b7dadc-333c-4803-a67e-92d38fd858a4' = 'Newari',
	'9314a3f9-8f64-4ee6-9cf5-d4319ef21124' = 'Nez Perce',
	'a425b50a-9075-4ff7-ad06-e542af031125' = 'Nigerian',
	'b536c61b-a186-4008-be17-f653c0141126' = 'Niuean',
	'ef4f697b-41de-4e71-a05d-c9e74df04387' = 'Northern Ndebele',
	'19cfca13-5039-4522-823d-e9ff8d19dbff' = 'Norwegian',
	'5425f3b0-b3c7-4954-9eba-14ec61622532' = 'Nuer',
	'34d838ea-4fb1-4518-b162-25620a8d42d3' = 'Nyanja (Chichewa)',
	'bc6bd222-8301-4b56-8bb2-b5a65cd71f35' = 'Nyankole (Nkore)',
	'c647d72c-b297-4119-8f28-0764d1251127' = 'Oriya',
	'213896c2-e91d-43cf-ab99-296ea135ebe2' = 'Oromo',
	'd758e83d-c3a8-422a-9039-1875e2361128' = 'Osmanli',
	'e869f94e-d4b9-433b-a14a-2986f3471129' = 'Ouolof',
	'f97b0a5f-e5ca-444c-b25b-3a9704581130' = 'Pahlavi',
	'1fcd40f4-5370-49dc-9d81-389dde36cd7a' = 'Palauan',
	'0a8c1b70-f6db-455d-936c-4ba815691131' = 'Pali',
	'd69587b7-0502-4bc0-bd50-745c49db68b5' = 'Pangasinan',
	'1b9d2c81-07ec-466e-a47d-5cb9267a1132' = "Papago / Tohono O'odham",
	'266c02f4-bbed-4380-8197-43038ea3b4de' = 'Papiamento',
	'2cae3d92-18fd-477f-b58e-6dca378b1133' = 'Pashai',
	'2fa3f168-548e-4186-af36-5e507a0b2837' = 'Pashto',
	'3dbf4ea3-290e-4880-869f-7edb489c1134' = 'Pedi',
	'4ed05fb4-3a1f-4991-97a0-8fec59ad1135' = 'Pele-Ata',
	'5fe170c5-4b30-4aa2-a8b1-90fd6abe1136' = 'Pere',
	'01937365-bced-411c-b0a3-4a2056fb7486' = 'Persian',
	'818f14d1-7801-4d8c-af35-98904817b7fc' = 'Pidgin Sign English',
	'60f281d6-5c41-4bb3-b9c2-a10e7bcf1137' = 'Pima',
	'710392e7-6d52-4cc4-cad3-b21f8cd01138' = 'Pingelapese',
	'e4a6a15c-c5b9-4672-9ec2-59ca26be8906' = 'Pohnpeian',
	'f6b915ac-9ac7-431b-bb56-dc555036ddd8' = 'Pokot',
	'8d70652f-72f7-48c8-8824-dcfb5d7ab73b' = 'Polish',
	'8f0d502b-ca7d-46a4-aef1-7aaea10caca5' = 'Ponapean/Pohnpeian',
	'395c94fd-70f3-433a-bcb9-95374d51861e' = 'Portuguese',
	'dcb22e7f-953b-4233-9586-49498fe508ba' = 'Portuguese (Brazil)',
	'fd2b43af-f42d-4b42-bc78-7d5f444809f0' = 'Portuguese (Portugal)',
	'8214a3f8-7e63-4dd5-8be4-c3209de11139' = 'Provencal',
	'9325b509-8f74-4ee6-9cf5-d431aef21140' = 'Pulau-Guai / Jah Hut',
	'0d67b72d-9b50-4650-9df0-74b7a806ab01' = 'Punjabi',
	'cec96811-a84a-4730-8127-d47c586a0048' = 'Purepecha',
	'a436c61a-9085-4ff7-ad06-e542bf031141' = 'Pushtu',
	'b547d72b-a196-4008-be17-f653d0141142' = 'Puyallup',
	'd699349b-5d9e-42fe-8427-170d632424a8' = 'Q’anjob’al',
	'c658e83c-b2a7-4119-8f28-0764e1251143' = "Q'eqchi'",
	'144991f4-8ee2-4db3-9669-ec0cd9d47b58' = 'Quechua',
	'2a6a2672-1a09-4f7c-9a68-58f3b742df2d' = "Quiche (K'iche)",
	'd769f94d-c3b8-422a-9039-1875f2361144' = 'Quileute',
	'e87b0a5e-d4c9-433b-a14a-298604471145' = 'Quinault',
	'c92c2a01-7fdb-41af-b64d-4562824a1932' = 'Rade',
	'd339e31b-1681-4f23-a35c-47a93fe0f715' = 'Rohinga',
	'2307b96c-5769-41d7-b2fc-fa5ab192010f' = 'Rohingya',
	'1a3adea5-0131-4d84-8761-1eaacf5f21cf' = 'Romanian',
	'f98c1b6f-e5da-444c-b25b-3a9715581146' = 'Romansch',
	'805440dc-0fa7-47d7-9ba8-38abb71e648c' = 'Runyakatira',
	'd1c2aae7-9018-42f7-b6b3-927857dfed06' = 'Russian',
	'0a9d2c80-f6eb-455d-936c-4baa26691147' = 'Rwanda',
	'1bae3d91-07fc-466e-a47d-5cbb377a1148' = 'Sahaptian',
	'2cbf4ea2-180d-477f-b58e-6dcc488b1149' = 'Saho',
	'3dd05fb3-291e-4880-869f-7edd599c1150' = 'Salish',
	'84972624-628c-4df0-8844-9fc9c8c2ede3' = 'Samoan',
	'b0bda389-db91-41fb-bf51-eac827209120' = 'San Miguel',
	'3f74d69e-f520-4a9f-aaba-4399d7045401' = 'Sango',
	'4ee170c4-3a2f-4991-97a0-8fee6aad1151' = 'Sanskrit',
	'58510e0e-8a91-4894-9507-1d6aa82091b1' = 'Santa Eulalia',
	'5ff281d5-4b40-4aa2-a8b1-90ff7bbe1152' = 'Sao',
	'd82e7246-1869-469e-8eaf-5c76ab47cdc4' = 'Saraiki',
	'600392e6-5c51-4bb3-b9c2-a1008ccf1153' = 'Saurashtra',
	'f5953cd8-a4bc-4a37-a160-ec24e4371694' = 'Sepedi (Northern Sotho)',
	'd379eabd-903d-48c2-ad53-88a1a640923a' = 'Serbian',
	'8d45cfb2-04e9-421a-8d33-e2883e26b6d4' = 'Serbo-Croatian',
	'e2ab72fb-934c-48cb-9709-9b2e77421aa5' = 'Serer',
	'68efc339-241f-404f-a4ed-c830a8e61bb5' = 'Shan',
	'eb14f886-59d3-4f54-a0ce-2fd7924c951b' = 'Shanghainese',
	'7114a3f7-6d62-4cc4-cad3-b2119dd01154' = 'Shina',
	'd257773d-e39c-4d2f-ac30-d4768fc31d64' = 'Shona',
	'bf05229f-fd0c-40d4-8e88-9e4eb76fe97f' = 'Sichuan',
	'166eac2f-3d66-46aa-b86c-787ead06453b' = 'Sinchuan (Szechuan)',
	'b9d0a5be-7364-4ff5-b30e-027861bbc526' = 'Sindhi',
	'744ac087-0001-4b7d-9505-6c1fe090abbe' = 'Sinhalese',
	'8225b508-7e73-4dd5-8be4-c322aee11155' = 'siSwati',
	'e958d10e-21ed-4d27-9fb1-842dc2e0a644' = 'Slovak',
	'77017eb2-6562-46ef-9452-4d4167e75475' = 'Slovene',
	'486886d7-1fa0-49e8-8fd2-212813261d94' = 'Slovenian',
	'9336c619-8f84-4ee6-9cf5-d433bff21156' = 'Sogdian',
	'7ed0b841-ea42-4349-8ee2-8826ad0a8466' = 'Somali',
	'0b8f33da-9c2a-4960-80c8-ec4a79951b16' = 'Soninke (Serahuli)',
	'1ac72d98-baa1-4433-8101-deafcbca8251' = 'Sorani',
	'c8690574-44c3-45bd-89a6-1689e9186c1a' = 'Spanish',
	'b558e83b-a1a6-4008-be17-f655e1141158' = 'Stoney',
	'1e67fcce-81b6-476f-8705-ef0625ba5d66' = 'Sudanese',
	'c669f94c-b2b7-4119-8f28-0766f2251159' = 'Suri',
	'83a13e6c-6b47-421b-b7f0-45aa294f0343' = 'Susu',
	'6436c3cd-58c5-4798-9747-18d531465db5' = 'Swahili',
	'97824c98-bf7d-47b0-80bb-8ef01115e1fc' = 'Swati (Swazi)',
	'd2d3f9a7-4ac9-437c-9f0c-8c5902038eee' = 'Swedish',
	'7581c9bc-c7be-43dd-a224-ae6ab5a489cf' = 'Tagalog',
	'397a9d64-455a-4057-87e9-aa631c50860f' = 'Tai Dam',
	'70ba7b2e-f903-4bb9-a527-95a0b7d505a4' = 'Taishanese',
	'55598328-15d9-4ff3-a959-b755165f8b35' = 'Taiwanese',
	'd77b0a5d-c3c8-422a-9039-187704361160' = 'Tajiki',
	'e88c1b6e-d4d9-433b-a14a-298815471161' = 'Tamazight / Tamazight-Standard Moroccan',
	'1edd4822-6c12-4d9b-8716-07e50965318c' = 'Tamil',
	'f99d2c7f-e5ea-444c-b25b-3a9926581162' = 'Tarasco / Purepecha',
	'35f5d2a6-ee48-447b-b6e1-db531a7bb719' = 'Tatar',
	'0aae3d90-f6fb-455d-936c-4baa37691163' = 'Tausug',
	'1bbf4ea1-080c-466e-a47d-5cbb488a1164' = 'Tedim Chin / Zomi',
	'd6cf9fe4-1e94-4ad2-9cae-185955e5c7a5' = 'Telugu',
	'e07d09dd-24b4-40cf-949c-9e9789f603b4' = 'Teochew (Chaozhou)',
	'7a02b5ae-af25-4884-95fc-02ea88bc3ab1' = 'Thai',
	'6faac626-b6eb-4656-b570-4dd043bd1091' = 'Tibetan',
	'5c3b0363-e7f8-4709-b98b-c21f65434d93' = 'Tigrigna (Tigrinya)',
	'2cd05fb2-191d-477f-b58e-6dcc599b1165' = 'Tiv',
	'3de170c3-2a2e-4880-869f-7edd6aac1166' = 'Tlingit',
	'4ef281d4-3b3f-4991-97a0-8fee7bbd1167' = 'Tocharian',
	'dca5dac3-f1b7-42ca-93ce-d848133e1d33' = 'Toisanese',
	'9dabbf35-b41c-4992-923b-60e2fc86a01a' = 'Toishanese (Toishan)',
	'eb095158-475d-4010-ab46-7415df730014' = 'Tongan',
	'5f0392e5-4c50-4aa2-a8b1-90008cce1168' = 'Triqui',
	'6014a3f6-5d61-4bb3-b9c2-a1119ddf1169' = 'Trukese',
	'0e6f2a9b-9cca-4555-8101-4bf5f87525fa' = 'Tswana',
	'7125b507-6e72-4cc4-cad3-b222aef01170' = 'Tswana / Setswana',
	'8236c618-7f83-4dd5-8be4-c333bff11171' = 'Tulu',
	'9347d729-8094-4ee6-9cf5-d444d0021172' = 'Tumbuka',
	'26b49298-684d-4743-9168-01251429d519' = 'Turkana',
	'c64fc4ab-0227-43b8-8df6-1d91b254f1cd' = 'Turkish',
	'a458e83a-91a5-4ff7-ad06-e555e1131173' = 'Turkmen',
	'd3e61ff7-44e7-4e52-acf6-d164aeb3877c' = 'Twi',
	'c67b0a5c-b3c7-4119-8f28-077704351175' = 'Twi / Cwi Bwamu',
	'4360f50d-f083-4d41-8798-9f69e0f4c833' = 'Tzeltal',
	'00854c98-840b-46eb-b912-5b5f2c645a34' = 'Tzotzil',
	'd78c1b6d-c4d8-422a-9039-188815461176' = 'Uduk',
	'e89d2c7e-d5e9-433b-a14a-299926571177' = 'Uigur',
	'f094a409-7c1e-41bb-8791-12072e4f438e' = 'Ukrainian',
	'c1f4b6aa-5d9e-4f71-8d3c-2e7a9b6f2201' = 'Unknown',
	'38904043-0e65-4b20-82ee-df6f682f72de' = 'Urdu',
	'0abf4ea0-f70b-455d-936c-4bbb48891179' = 'Urian',
	'1bd05fb1-081c-466e-a47d-5ccc599a1180' = 'Ute',
	'4c855a3f-9cc1-4e70-ad88-5c05072f6b13' = 'Uzbek',
	'0b81cb15-0c46-4d1a-9a68-abf46701b451' = 'Venda',
	'2736636d-ea4d-4e2b-bcb6-face84195958' = 'Vietnamese',
	'd3dd4292-31ee-4069-923a-e76d086300b1' = 'Visayan',
	'44a29cb2-b6d6-4b43-b595-b43dfc884fc8' = 'Visayan-Cebuano',
	'2ce170c2-192d-477f-b58e-6ddd6aab1181' = 'Waray-Waray',
	'3df281d3-2a3e-4880-869f-7eee7bbc1182' = 'Washo',
	'a7d1b56c-4fe7-4d31-a726-8d21aa7ba42c' = 'Welsh',
	'4e0392e4-3b4f-4991-97a0-8fff8ccd1183' = 'Wolaytta',
	'f355ddc2-9147-407b-b086-469b35556784' = 'Wolof',
	'5c2c063f-d77e-4b9a-9efa-57fc54b39201' = 'Xhosa',
	'8148eea3-fb54-4acf-828e-0dd86e5cce13' = 'Xitsonga (Tsonga)',
	'5f14a3f5-4c60-4aa2-a8b1-90109dde1184' = 'Yakama',
	'6025b506-5d71-4bb3-b9c2-a121aee01185' = 'Yakut',
	'7136c617-6e82-4cc4-cad3-b232bff11186' = 'Yao',
	'a61e2249-c7ae-4b14-908e-fd6ede093b10' = 'Yapese',
	'68d7385d-300f-4e20-8b12-6a15e8bfdb8d' = 'Yiddish',
	'8247d728-7f93-4dd5-8be4-c343d0021187' = 'Yis',
	'b360c1fb-1205-4fb3-83b0-b58fff17418f' = 'Yoruba',
	'6b38fe92-1bc2-4b56-939f-77c769dc0e7d' = "Yup'ik",
	'0037aa8a-2610-4eb8-b8e5-331ca438fc93' = 'Zapoteco',
	'7876b1cf-9fa9-49f2-b725-51d12b464d14' = 'Zarma',
	'a469f94a-91b5-4ff7-ad06-e565f2241189' = 'Zezeru',
	'b57b0a5b-a2c6-4008-be17-f67704351190' = 'Zigula',
	'41ca517e-e282-4efe-a1ba-cc5e4c5163e6' = 'Zomi',
	'9668f20c-f941-444b-8472-83132d18834c' = 'Zou (Zomi)',
	'cd9923d4-de2c-4739-9fd8-e273391d5c8b' = 'Zulu',
}

export enum LanguageToCountryCodeEnum {
	'c2c3a9de-8a5b-4f0d-9d26-0e4b4e3a1001' = 'GE',
	'5a765850-67a6-4db0-8ca2-7ba976ab6c41' = 'UG',
	'8dc46505-2748-4fe6-844b-92e9bf680f89' = 'ET',
	'9dfcea09-653d-40dd-ba2f-392b81d4d04a' = 'AF',
	'a8396f3c-b9e3-4637-b81c-74569c4a96d0' = 'ZA',
	'8f0a7e22-3b6d-4fb4-8d9d-1c7c9b201002' = 'GT',
	'7783fbeb-51db-47a5-a96e-a2baabfc96b4' = 'GH',
	'c7e44be1-7100-4f9d-b88a-cec0b7bf50a8' = 'GH',
	'81d267a8-d222-4a3e-b472-911b0ce63f6d' = 'UG',
	'74a6c47a-0e99-42a8-96ee-aff3e50db61d' = 'AL',
	'b1fd6776-b8d1-4f52-97c7-9108fc0cd682' = 'DZ',
	'5b81f1a4-7c1e-4c90-bb8d-2d7e6f301003' = 'US',
	'4594ef6d-6620-482f-abdc-04fc6c87e06f' = 'SS',
	'8b7cda98-5389-4562-94e4-c6abd7cc5752' = 'US',
	'e0e31d26-4aab-4626-8785-a713226088cc' = 'ET',
	'5cc22b06-f4ad-434b-92ff-d49cfb2cd67f' = 'SS',
	'2e5dc4b7-9a82-45d0-90de-3f8b7a401004' = 'US',
	'a07b8dbc-6cf7-4347-9a8c-dd6913aea598' = 'SA',
	'7d96cb21-1f3c-46ba-9e3e-4b9c8d501005' = 'EG',
	'9b4f1a33-2d7a-4e81-b644-5ca9de601006' = 'IQ',
	'1c8a7e44-3e9b-4af5-a8a1-6db0ef701007' = 'JO',
	'4d7b9f55-4af0-46d2-bd8b-7ec1fa801008' = 'SY',
	'6e8c0a66-5bc1-4b31-ae52-8fd20b901009' = 'LY',
	'7f9d1b77-6cd2-4cb4-9f73-90e31ca01010' = 'MA',
	'80ae2c88-7de3-4dc5-8b84-a1f42db11011' = 'PS',
	'91bf3d99-8ef4-4ed6-9c95-b2053ec21012' = 'SA',
	'a2c04eaa-9f05-4fe7-ad06-c3164fd31013' = 'SY',
	'b3d15fbb-a016-40f8-be17-d42750e41014' = 'TN',
	'c4e260cc-b127-4109-8f28-e53861f51015' = 'YE',
	'c60392ec-b257-4119-8f28-f745a0251063' = 'BZ',
	'd5f371dd-c238-421a-9039-f64972061016' = 'US',
	'a04fd751-bb02-4e32-994b-cfbe34901318' = 'AM',
	'13aa1e33-06da-4168-892a-d067a274d301' = 'GH',
	'6a95dcef-511b-4af9-bd4a-2eea6212b7fa' = 'IQ',
	'0a26a500-f56b-454d-936c-297ca5391019' = 'BO',
	'0beb5e15-b628-4299-81d4-8bad3709a17f' = 'UG',
	'1b37b611-067c-465e-a47d-3a8db64a1020' = 'ML',
	'f71593ff-e45a-443c-b25b-186b94281018' = 'IN',
	'e60482ee-d349-432b-a14a-075a83171017' = 'IN',
	'9c22c966-2456-4bb0-bcc5-26fda529f3dc' = 'AZ',
	'85c86964-74b6-48ca-8188-c6b907e8176a' = 'AZ',
	'65633d12-fc60-4e61-a76d-27fe8130eb45' = 'PT',
	'ab069cbb-0a88-4890-bd8d-1e641ee132f0' = 'ID',
	'29fd77fe-e64f-4726-a375-03f0c38c0179' = 'VN',
	'3d59d833-289e-4880-869f-5cad086c1022' = 'PK',
	'2c48c722-178d-476f-b58e-4b9ec75b1021' = 'ID',
	'2367d55f-0e48-4bbe-97ef-5dad3b540479' = 'ML',
	'4e6ae944-39af-4991-97a0-6dbe197d1023' = 'ML',
	'00e2a1a0-db1d-4835-a63f-a0c296b50a2d' = 'BD',
	'5b9cc8d0-bdfe-4bf2-b508-ad12550695d4' = 'ZA',
	'e171ee74-ccd8-4e2d-9bb3-12fc01e36935' = 'SS',
	'0dea3bcf-c90c-49e4-8831-adfc2ed56ade' = 'RU',
	'0dedb77c-87df-4bfa-be4f-4e6c8d6afb2c' = 'BE',
	'66882204-97b1-4aea-a30b-1d6479b42d30' = 'ES',
	'11ff9035-dc4f-4eb5-9de4-7b52770b8c2c' = 'LR',
	'47ea1d52-c673-4ea5-8558-af723f1b6813' = 'BY',
	'fe6c2d6e-7507-4bb0-9a78-06782dea5d18' = 'ZM',
	'e09a0668-94a0-49c5-8e6c-3b39eebc4d79' = 'BD',
	'b54df014-b596-41e4-a777-bb2683da986b' = 'BT',
	'5f7bfa55-4ac0-4aa2-a8b1-7ecf2a8e1024' = 'MA',
	'608c0b66-5bd1-4bb3-b9c2-8fe03b9f1025' = 'PH',
	'719d1c77-6ce2-4cc4-cad3-90f14cb01026' = 'ER',
	'82ae2d88-7df3-4dd5-8be4-a2015dc11027' = 'PH',
	'6b92a29a-c3fe-4290-8efa-1f6730ede4c0' = 'BA',
	'926ecb44-553d-4479-b561-b9da8d507d0d' = '',
	'37996bd4-39ec-4162-b5ff-7945446da29c' = 'BG',
	'93bf3e99-8e04-4ee6-9cf5-b3126ed21028' = 'KE',
	'a4c04faa-9f15-4ff7-ad06-c4237fe31029' = 'RU',
	'b5d160bb-a126-4008-be17-d53480f41030' = 'BY',
	'c6e271cc-b237-4119-8f28-e64591051031' = 'GT',
	'c2521484-487a-494a-95a5-1cf1f24766b0' = 'MM',
	'6932e24c-96b1-4afd-9d92-b6407fb6c5a4' = 'KH',
	'4a162f5d-4c2b-45e6-8016-97473f8d6d39' = 'KH',
	'544318fb-f206-42a5-9e08-852ccba83fd6' = 'CV',
	'd7f382dd-c348-422a-9039-f756a2161032' = 'CN',
	'e80493ee-d459-433b-a14a-0867b3271033' = 'US',
	'bb0248f8-5cae-450c-be8a-788974a8ad48' = 'AD',
	'7c869fea-967a-4f88-9cc8-c8faef4a00b1' = 'PH',
	'f915a4ff-e56a-444c-b25b-1978c4381034' = 'TR',
	'78fd82b0-8954-433b-b5c5-e3e0dad78ddc' = 'SY',
	'0a26b510-f67b-455d-936c-2a89d5491035' = 'GT',
	'1b37c621-078c-466e-a47d-3b9ae65a1036' = 'VN',
	'1f2146e1-05b2-43b0-ba6b-15b49161b075' = 'GU',
	'2dfd73c6-1637-4bbd-9f85-a7aeffc4b824' = 'CN',
	'2c48d732-189d-477f-b58e-4cabf76b1037' = 'PH',
	'3d59e843-29ae-4880-869f-5dbca87c1038' = 'RU',
	'4e6af954-3abf-4991-97a0-6ecdb98d1039' = 'RU',
	'5f7c0a65-4bd0-4aa2-a8b1-7fdec99e1040' = 'ZM',
	'126ad9a5-de25-4ca2-8559-8e27b933d0b0' = 'CN',
	'dade64da-f203-45fd-aa96-55c3377f3bba' = 'IN',
	'83886345-19d8-4acb-8ffe-9601178e6cf5' = 'MM',
	'bfcf8c26-a53c-44d0-9cc5-a7080b51a750' = 'MM',
	'0b615231-a61e-448f-9e59-1c280adecc66' = 'CN',
	'257d480a-a42f-400c-af47-ff7c79271284' = 'CN',
	'cfd903d5-8042-4e50-b1f3-6f909cda9f10' = 'CN',
	'9a2353ee-5b3c-4a5a-af75-f23a65d31015' = 'CN',
	'2be21b70-40e2-4aa9-a5ed-c2f52b1cc149' = 'CN',
	'a216c732-e059-4aae-bcbc-e525ef45c1cc' = 'JP',
	'6fcb940f-a629-4179-9541-99975aeb097f' = 'CN',
	'c975cc43-1bdb-40af-88ed-98ec29aeae15' = 'GT',
	'45691712-7021-45e6-82aa-1d6a8071e526' = 'FM',
	'd73650d0-d63b-4e9a-8232-43fde44e4217' = 'FM',
	'd736c61d-c388-422a-9039-1876b1361096' = 'IN',
	'608d1b76-5ce1-4bb3-b9c2-80efdaaf1041' = 'CN',
	'719e2c87-6df2-4cc4-cad3-91f0ebc01042' = 'US',
	'82af3d98-7e03-4dd5-8be4-a301fcd11043' = 'FM',
	'93c04ea9-8f14-4ee6-9cf5-b4120de21044' = 'RU',
	'a4d15fba-9025-4ff7-ad06-c5231ef31045' = 'US',
	'b5e270cb-a136-4008-be17-d6342f041046' = 'EG',
	'b5f281db-a146-4008-be17-e6349f141062' = 'IE',
	'c6f381dc-b247-4119-8f28-e74540151047' = 'GB',
	'd70492ed-c358-422a-9039-f85651261048' = 'CA',
	'e34120bd-37a8-41ba-b017-39b5da47b4d0' = 'CI',
	'64bde62f-fb19-46bb-bd75-46cd504de9d3' = 'HT',
	'4fc08ae5-102b-428d-8722-56de18ea22bb' = 'HR',
	'e815a3fe-d469-433b-a14a-096762371049' = 'US',
	'e825b50e-d479-433b-a14a-1967c2471065' = 'ET',
	'b0db886a-bc26-4c93-8384-53a29fb3d959' = 'CZ',
	'f926b50f-e57a-444c-b25b-1a7873481050' = 'GH',
	'f4cbf901-57b2-457e-be88-c8cdf68c9379' = 'DK',
	'e4bd6a13-f6e5-40f3-8b96-45a35a08e585' = 'AF',
	'31b0e622-8069-48e9-b006-8b7858a60178' = 'AF',
	'03b432ef-d0c9-4135-8882-77f4956ea9d7' = '',
	'aa6475ea-7c74-41ad-b7e9-a57f192c8682' = 'CA',
	'0a37c620-f68b-455d-936c-2b8984591051' = 'AU',
	'1b48d731-079c-466e-a47d-3c9a956a1052' = 'NG',
	'250f68e4-4bae-4957-a2f2-88b80c95d393' = 'CI',
	'1d642173-3180-43cc-b1b2-43a2b5506936' = 'SS',
	'2c59e842-18ad-477f-b58e-4dab067b1053' = 'NG',
	'abf9b57a-4167-4a99-be70-38c7accd30df' = 'CM',
	'0f3b015e-a636-460e-b2a0-dec545b3284f' = 'NL',
	'3d6af953-29be-4880-869f-5ebc178c1054' = 'NG',
	'8f1c6b0b-1d02-40c9-85d5-0c1885bf6e3a' = 'NG',
	'6a878217-8c3c-4d92-8878-5f10d3dc92a5' = 'EG',
	'ed632db3-184c-4b07-b3ae-b58a933df525' = 'KE',
	'2db19439-b440-4c31-aad4-190bca9b1a3f' = 'US',
	'f0feb318-c249-4039-9625-6821f023e13d' = 'AU',
	'34e320e8-7b99-46c5-a745-9b85ddd3bbb2' = 'GB',
	'02f418f8-eb5e-48d5-8814-58c77da57f6c' = 'US',
	'4e7b0a64-3acf-4991-97a0-6fcd289d1055' = 'ER',
	'797fbb62-c65f-4cc7-bb51-06269bf3b7de' = 'EE',
	'5f8c1b75-4be0-4aa2-a8b1-80de39ae1056' = 'ET',
	'5f9d2c85-4bf0-4aa2-a8b1-90de39be1072' = 'US',
	'067f4bf8-3241-4c2c-adf2-b2cdb9c06a97' = 'TG',
	'609d2c86-5cf1-4bb3-b9c2-91ef4abf1057' = 'IQ',
	'60ae3d96-5c01-4bb3-b9c2-a1ef4acf1073' = 'US',
	'7436cdf7-3785-4c8f-bef4-6545385501a1' = 'GH',
	'ad08d695-2653-458d-96d1-b76637b65176' = 'GH',
	'1867ad6d-325d-4730-9878-a2215beb80df' = 'IR',
	'bd140e42-f0a4-4aab-9f18-608f9a85f8af' = 'FJ',
	'71ae3d97-6d02-4cc4-cad3-a2f05bd01058' = 'GH',
	'0e7a1d70-4ed4-4cfb-8d22-d235c2782e31' = 'FR',
	'cde31079-811e-43cd-9bde-3be38f5993b8' = 'CA',
	'a86a4dca-a6e0-45b4-a7ea-615c48dbe31a' = 'SC',
	'7cb7bb48-40fc-4a2a-b2e9-feb8e90afb15' = 'CN',
	'e11043ff-7ed7-4feb-b9bd-87eea1536cc3' = 'CN',
	'898a96b6-8ef7-4b62-b031-0ccc954c60f6' = 'NG',
	'82bf4ea8-7e13-4dd5-8be4-b3016ce11059' = 'CM',
	'93d05fb9-8f24-4ee6-9cf5-c4127df21060' = 'NG',
	'f574d936-8e24-453a-a58f-a121bdd261ec' = 'CN',
	'a4e170ca-9035-4ff7-ad06-d5238e031061' = 'SU',
	'c290afff-529b-4e24-9e7b-27f0928eca1c' = 'CM',
	'c918371a-74da-4dc2-b298-d2adc8c1037d' = 'CN',
	'64c390c4-0679-45ed-8cd5-ca1e5c75be71' = 'GH',
	'e248c1f9-fa1d-49d2-a539-4748dbb19058' = 'ES',
	'0a6be8be-d6af-4d43-a6da-dcbcfe6c0123' = 'ET',
	'8a4c7cc4-9cbf-4d5f-a3ca-a1c9cdbcd0f7' = 'TG',
	'd714a3fd-c368-422a-9039-0856b1361064' = 'KI',
	'573d4a12-b542-415c-888b-df1d3629c275' = 'GE',
	'576ec02a-64b4-4d15-bbc5-8a05e45d956c' = 'FI',
	'25628cf7-0bf3-4d02-b8b6-2fcbe67e7e95' = 'DE',
	'a089c286-4831-4a85-b77c-57d81907c9f7' = 'UG',
	'9349ccc1-af60-499a-a41e-2e0f4bd41e9d' = 'NG',
	'20ab2178-144d-43a4-85d3-7500edbbe99c' = 'GR',
	'f936c61f-e58a-444c-b25b-2a78d3581066' = 'GR',
	'0a47d730-f69b-455d-936c-3b89e4691067' = 'US',
	'b79a4514-2144-4a67-9b03-f91112b2e258' = 'BR',
	'0e2d88f9-3457-427f-90af-8c32abcc0df0' = 'IN',
	'04f781fc-3496-4b50-abc8-2039731acb4e' = 'KE',
	'1b58e841-07ac-466e-a47d-4c9af57a1068' = 'US',
	'd3404df9-6c6b-4f05-a412-2fd5027e1701' = 'CN',
	'5b522bc7-a6cb-428b-b77b-8f70d0d46bbe' = 'HT',
	'd65eabac-708c-4815-a77a-af943e465a65' = 'HT',
	'2c7b0a62-18cd-477f-b58e-6dba068b1085' = 'MM',
	'8dcdb72c-29b5-4e09-9614-533e61034c08' = 'MM',
	'2e7e6dd8-1efd-412e-bcfc-c38b3bda1259' = 'MM',
	'1bedd84c-0ed3-43b5-90fe-cd87470a0236' = 'CN',
	'1c554a41-d233-408c-9bf9-389457b7473d' = 'PH',
	'2c69f952-18bd-477f-b58e-5dab068b1069' = 'US',
	'3d7b0a63-29ce-4880-869f-6ebc179c1070' = 'US',
	'3d8c1b73-29de-4880-869f-7ecb179c1086' = 'IN',
	'3db1644c-2c1c-499e-93f6-dc38e05126a3' = 'MR',
	'd9593e75-b04e-4151-9211-b79ac8c6da95' = 'NG',
	'62601570-a226-4d77-9ca8-5d1bd22fbfe5' = 'IL',
	'4e8c1b74-3adf-4991-97a0-7fcd28ad1071' = 'NA',
	'4e9d2c84-3aef-4991-97a0-8fdc28ad1087' = 'BR',
	'9bb26d49-548c-4601-b5d2-787c005dac9b' = 'IN',
	'a1c2cf4d-12df-4539-b27c-9e6463b07c13' = 'CN',
	'afe447f5-c553-4591-b17a-171185f6cee2' = 'HU',
	'71bf4ea7-6d12-4cc4-cad3-b2f05bd01074' = 'PH',
	'cfda3fe3-2495-44de-9697-eefd85318570' = 'NG',
	'82d05fb8-7e23-4dd5-8be4-c3016ce11075' = 'IS',
	'1260d8a9-6910-4827-9594-8959dec2ef1e' = 'IS',
	'8cd02bd9-f9e4-419b-bde9-3e00c680ec33' = 'NG',
	'179480b2-f242-4387-9c3a-391cf9318df6' = 'PH',
	'705a44e4-8a65-474d-b57a-0faa47cdb0ab' = 'PH',
	'93e170c9-8f34-4ee6-9cf5-d4127df21076' = 'CA',
	'a4f281da-9045-4ff7-ad06-e5238e031077' = 'US',
	'f28dc149-350f-4415-9343-9fcbd3e0c04c' = 'MX',
	'df7ef064-c365-4005-a4ec-7db39f16d40e' = 'ID',
	'062de6e8-cc65-41cb-bfb7-caf9da5279f5' = 'IE',
	'b50392eb-a156-4008-be17-f6349f141078' = 'IN',
	'32d76a50-7bfa-4879-8bd8-6158ac475977' = 'IT',
	'c614a3fc-b267-4119-8f28-0754a0251079' = 'JM',
	'c625b50c-b277-4119-8f28-0765a0251095' = 'LA',
	'd725b50d-c378-422a-9039-1865b1361080' = 'JM',
	'e9580144-071c-451d-bb52-369b17035f98' = 'JP',
	'105a35df-8fc4-4d19-b97b-a84c9956b4db' = 'VN',
	'23085fcd-99cd-432d-b3bf-5f8cbc92f316' = 'ID',
	'17a1f079-791a-469b-872f-4808913e867e' = 'CN',
	'e836c61e-d489-433b-a14a-2976c2471081' = 'SN',
	'f947d72f-e59a-444c-b25b-3a87d3581082' = 'IL',
	'431cdbd0-18ff-45ea-a0c9-cfd88e6718fa' = 'MM',
	'0a58e840-f6ab-455d-936c-4b98e4691083' = 'UG',
	'39b39dd9-1669-435f-864c-e00bf85474b1' = 'KE',
	'dd363f46-0e49-461b-93a5-f15eb9fad29c' = 'KE',
	'ddb7a1c9-fac2-4f5c-847d-e5544830d19f' = 'SL',
	'9aed5374-e709-4369-b2e8-52200597e48f' = 'GT',
	'1b69f951-07bc-466e-a47d-5ca9f57a1084' = 'PH',
	'0fb7fa00-c2fb-4a55-b28e-ce03e7e33274' = 'IN',
	'3c17ac2c-b75d-4ad7-93a3-34ca46c0c773' = 'PH',
	'4f7fbecb-38eb-402c-a645-cce86c04639d' = 'MM',
	'aecd5ff6-b1bd-45e8-8a93-250fbbedf1ca' = 'MM',
	'ae25fe46-cd72-43a7-b967-05353c000440' = 'MM',
	'8bb38f41-7524-4dfc-aa09-e9771b003f7d' = 'KZ',
	'52a16c5e-54f9-40b0-bef5-b8ede3887e9f' = 'KH',
	'5fae3d95-4b00-4aa2-a8b1-90ed39be1088' = 'MN',
	'deb110da-f8ba-44e5-a9ae-3558f06cd77d' = 'KE',
	'b84fff33-5bb9-4241-84fb-861543c53523' = 'GT',
	'60bf4ea6-5c11-4bb3-b9c2-a1fe4acf1089' = 'GT',
	'cad2149a-ac1c-4717-8c10-77fd9843af0d' = 'UG',
	'71d05fb7-6d22-4cc4-cad3-b20f5bd01090' = 'KE',
	'a44715a7-9495-4a59-a0bf-0198a7e5ccc5' = 'CG',
	'fe94315d-6f92-4ff8-9c5f-daee9ce3044a' = 'KE',
	'f683afc0-8e46-4768-92a3-a5fbf702f174' = 'CG',
	'21a9d9b2-9522-4752-9224-b7cf9d393a8f' = 'RW',
	'93f281d9-8f44-4ee6-9cf5-d4327df21092' = 'KI',
	'82e170c8-7e33-4dd5-8be4-c3216ce11091' = 'KG',
	'137126bb-eaae-4c4f-95ea-9cfe2b255c6e' = 'BI',
	'a40392ea-9055-4ff7-ad06-e5438e031093' = 'MD',
	'f9647f43-45e7-42b3-8436-f317f7d16368' = 'KE',
	'd2b9861f-89ff-4f64-a311-20b1e683d3fb' = 'CG',
	'd3e9d64b-23c5-4c53-b763-6402b0227602' = 'VN',
	'5ed7ece8-f51c-47d7-80a9-9951e7dafdbd' = 'KR',
	'2569522a-dfe5-45d9-b91f-baf726543ab9' = 'FM',
	'2c55f8d5-f939-4512-b34a-fc631ebc860c' = 'LR',
	'916f0588-6e8b-4f02-a6b7-03e1c4442871' = 'LR',
	'a8a53400-1fe0-4038-97c1-9ffc10351388' = 'KW',
	'e847d72e-d499-433b-a14a-2987c2471097' = 'US',
	'90668c05-9ce0-447c-b5fc-d65b3dc0ff25' = 'ER',
	'd6acb0a2-73b3-4988-852c-2cc5023295c8' = 'TR',
	'f958e83f-e5aa-444c-b25b-3a98d3581098' = 'IQ',
	'59e195db-2933-4245-9bb3-7e6efc59976a' = 'TR',
	'5a80059f-abd3-4eed-976d-82d920fa4ffe' = 'KG',
	'0a69f950-f6bb-455d-936c-4ba9e4691099' = 'US',
	'9cf5f8cb-d873-4e86-89cb-69601968b201' = 'UG',
	'c4c7c8f5-54f8-4fcd-8cbc-720a59938bb0' = 'LA',
	'1b7b0a61-07cc-466e-a47d-5cba057a1100' = 'FI',
	'3735b958-c56d-4def-94ff-38b8f87901d7' = 'VA',
	'45eca50d-4d98-4917-8202-c90b54872e7b' = 'LV',
	'869b0d52-fe70-4720-beb3-9d71b73776a8' = 'SB',
	'd7913cf5-1608-49b4-bebf-b503b080c854' = 'LB',
	'd49d5677-8466-4f8f-8115-a1d5a44ff89c' = 'CG',
	'2c8c1b72-18dd-477f-b58e-6dcb168b1101' = 'SA',
	'a5430f7f-8366-46ef-af08-930918dc6bbe' = 'LT',
	'a980cc10-b9f1-4778-a392-27c580a7115a' = 'LR',
	'4943a69a-0937-45cf-8369-5155c49841e4' = 'UG',
	'6614e1e2-27a6-4a0f-abee-2273672649e6' = 'UG',
	'3d9d2c83-29ee-4880-869f-7edc279c1102' = 'CN',
	'75581ee7-52e7-4042-a173-55444953acc9' = 'KE',
	'48e82dc1-3026-42c5-9109-f270802d7b25' = 'KE',
	'1a0f80dc-4127-4970-bd4f-1796464c492f' = 'UG',
	'8ff56c18-edcf-4118-bbbf-cdfffe6ce56b' = 'KE',
	'98b69d39-8c4e-4541-a9c3-25e01225b8db' = 'SO',
	'd2501282-651f-4349-beb0-42895fe3220e' = 'MK',
	'4eae3d94-3aff-4991-97a0-8fed38ad1103' = 'US',
	'48c63fba-a7d2-4bd0-a1ab-49f1029580fa' = 'NP',
	'904cdfa4-1a28-4ed1-bdd7-fd25cc82a356' = 'MG',
	'98a24fe0-81ce-4380-821c-d6f4d75b17d3' = 'MY',
	'92515f47-3978-4bdf-ba5f-ffffae2d2a21' = 'IN',
	'133ac696-188a-4982-9351-84f218f6710c' = 'MY',
	'c9879de9-671c-4461-8224-080b8b2d45eb' = 'ML',
	'44e3ab1e-96f1-44a9-a92a-37fd270d25ce' = 'MT',
	'5fbf4ea5-4b10-4aa2-a8b1-90fe49be1104' = 'TZ',
	'60d05fb6-5c21-4bb3-b9c2-a10f5acf1105' = 'MZ',
	'6942808f-b0bc-42d4-9112-e5b063aec1e0' = 'GT',
	'71e170c7-6d32-4cc4-cad3-b21f6bd01106' = 'CN',
	'82f281d8-7e43-4dd5-8be4-c3207ce11107' = 'GM',
	'8acae6ee-7e75-4da6-8cb2-69a3e4ca9f70' = 'GM',
	'930392e9-8f54-4ee6-9cf5-d4318df21108' = 'KE',
	'a414a3fa-9065-4ff7-ad06-e5429e031109' = 'RU',
	'b525b50b-a176-4008-be17-f653af141110' = 'ML',
	'81d24ec2-044a-4f9e-9a1c-7332ed025e7f' = 'KE',
	'c636c61c-b287-4119-8f28-0764c0251111' = 'PF',
	'67bb0085-48b5-49b3-a3ee-6b75cf641e6d' = 'IN',
	'a66dba08-62a9-41db-8211-ac02727234aa' = 'MH',
	'8c709623-f769-4a79-b4b6-a185473f06a6' = 'CI',
	'd747d72d-c398-422a-9039-1875d1361112' = 'CA',
	'c3fe438a-2e59-4691-a07d-c06cf34ffadc' = 'SO',
	'20f03669-19a5-48f3-9a8a-55d04381c83e' = 'MX',
	'cbbdd8bf-a3ad-455f-bd2b-7a1c92768a16' = 'MX',
	'7deb76d3-ac37-4b62-b07e-9bd798170b58' = 'GT',
	'5d997111-b45f-44b1-931a-94d7593ee8cd' = 'GW',
	'5a6062f6-f65b-4905-aa17-c938b6fa5270' = 'SL',
	'bcbfd429-a0d7-4b8e-ba11-8eba9370de17' = 'KE',
	'f733d3ca-8ff8-4e01-950f-76cc9ed9427e' = 'CN',
	'2d3a560a-c1c8-471c-8b74-a2fdb2140ee1' = 'TG',
	'5419fa34-0278-42db-8364-e456fe1438c2' = 'ID',
	'e858e83e-d4a9-433b-a14a-2986e2471113' = 'CN',
	'1044a781-c22c-4bbb-b95f-53d012bae46a' = 'MX',
	'66c19812-3253-46c2-bd03-da4fafb8cceb' = 'MX',
	'6fcc5068-045f-43f7-9855-6345c16e4278' = 'MX',
	'0a7b0a60-f6cb-455d-936c-4ba805691115' = 'TH',
	'f969f94f-e5ba-444c-b25b-3a97f3581114' = 'IN',
	'649bc8ca-4365-40d1-8f4e-16f35201f4da' = 'VN',
	'241bb0a6-728a-4021-aece-d2fe464382bb' = 'MD',
	'1b8c1b71-07dc-466e-a47d-5cb9167a1116' = 'FM',
	'868fd2a4-6f4d-4eff-86df-64bd986879ae' = 'MN',
	'4416c7ae-b65f-428f-b0db-e255f312a3bd' = 'ME',
	'2c9d2c82-18ed-477f-b58e-6dca278b1117' = 'RU',
	'3dae3d93-29fe-4880-869f-7edb389c1118' = 'FM',
	'4ebf4ea4-3a0f-4991-97a0-8fec49ad1119' = 'US',
	'5fd05fb5-4b20-4aa2-a8b1-90fd5abe1120' = 'NG',
	'49584f0b-7859-46c5-af7d-83aeac869265' = 'CI',
	'60e170c6-5c31-4bb3-b9c2-a10e6bcf1121' = 'RU',
	'18b71a9c-7fa3-47dd-bb51-e9da3a196639' = 'MX',
	'e358c716-26d2-46ab-a038-58cc8d277f12' = 'US',
	'71f281d7-6d42-4cc4-cad3-b21f7cd01122' = 'KE',
	'73fff926-5e71-48ad-aff5-65f3403f12b0' = 'NZ',
	'820392e8-7e53-4dd5-8be4-c3208de11123' = 'ZW',
	'af78f3dc-0eab-4cd4-a4ab-2c7cdfbb8160' = 'NP',
	'68b7dadc-333c-4803-a67e-92d38fd858a4' = 'NP',
	'ef4f697b-41de-4e71-a05d-c9e74df04387' = 'ZW',
	'9314a3f9-8f64-4ee6-9cf5-d4319ef21124' = 'US',
	'a425b50a-9075-4ff7-ad06-e542af031125' = 'NG',
	'b536c61b-a186-4008-be17-f653c0141126' = 'NU',
	'19cfca13-5039-4522-823d-e9ff8d19dbff' = 'NO',
	'5425f3b0-b3c7-4954-9eba-14ec61622532' = 'SS',
	'34d838ea-4fb1-4518-b162-25620a8d42d3' = 'ZM',
	'bc6bd222-8301-4b56-8bb2-b5a65cd71f35' = 'UG',
	'c647d72c-b297-4119-8f28-0764d1251127' = 'IN',
	'213896c2-e91d-43cf-ab99-296ea135ebe2' = 'ET',
	'd758e83d-c3a8-422a-9039-1875e2361128' = 'TR',
	'e869f94e-d4b9-433b-a14a-2986f3471129' = 'SN',
	'f97b0a5f-e5ca-444c-b25b-3a9704581130' = 'IR',
	'0a8c1b70-f6db-455d-936c-4ba815691131' = 'LK',
	'1b9d2c81-07ec-466e-a47d-5cb9267a1132' = 'US',
	'd69587b7-0502-4bc0-bd50-745c49db68b5' = 'PH',
	'2cae3d92-18fd-477f-b58e-6dca378b1133' = 'AF',
	'2fa3f168-548e-4186-af36-5e507a0b2837' = 'PK',
	'3dbf4ea3-290e-4880-869f-7edb489c1134' = 'ZA',
	'4ed05fb4-3a1f-4991-97a0-8fec59ad1135' = 'ID',
	'5fe170c5-4b30-4aa2-a8b1-90fd6abe1136' = 'VN',
	'b360c1fb-1205-4fb3-83b0-b58fff17418f' = 'NG',
	'1fcd40f4-5370-49dc-9d81-389dde36cd7a' = 'PW',
	'266c02f4-bbed-4380-8197-43038ea3b4de' = 'AW',
	'01937365-bced-411c-b0a3-4a2056fb7486' = 'IR',
	'818f14d1-7801-4d8c-af35-98904817b7fc' = '',
	'60f281d6-5c41-4bb3-b9c2-a10e7bcf1137' = 'US',
	'710392e7-6d52-4cc4-cad3-b21f8cd01138' = 'FM',
	'e4a6a15c-c5b9-4672-9ec2-59ca26be8906' = 'FM',
	'f6b915ac-9ac7-431b-bb56-dc555036ddd8' = 'KE',
	'8d70652f-72f7-48c8-8824-dcfb5d7ab73b' = 'PL',
	'8f0d502b-ca7d-46a4-aef1-7aaea10caca5' = 'FM',
	'395c94fd-70f3-433a-bcb9-95374d51861e' = 'PT',
	'dcb22e7f-953b-4233-9586-49498fe508ba' = 'BR',
	'fd2b43af-f42d-4b42-bc78-7d5f444809f0' = 'PT',
	'8214a3f8-7e63-4dd5-8be4-c3209de11139' = 'FR',
	'9325b509-8f74-4ee6-9cf5-d431aef21140' = 'MY',
	'0d67b72d-9b50-4650-9df0-74b7a806ab01' = 'IN',
	'cec96811-a84a-4730-8127-d47c586a0048' = 'MX',
	'a436c61a-9085-4ff7-ad06-e542bf031141' = 'AF',
	'b547d72b-a196-4008-be17-f653d0141142' = 'US',
	'c658e83c-b2a7-4119-8f28-0764e1251143' = 'GT',
	'd699349b-5d9e-42fe-8427-170d632424a8' = 'GT',
	'd769f94d-c3b8-422a-9039-1875f2361144' = 'US',
	'e87b0a5e-d4c9-433b-a14a-298604471145' = 'US',
	'144991f4-8ee2-4db3-9669-ec0cd9d47b58' = 'PE',
	'2a6a2672-1a09-4f7c-9a68-58f3b742df2d' = 'GT',
	'c92c2a01-7fdb-41af-b64d-4562824a1932' = 'VN',
	'f98c1b6f-e5da-444c-b25b-3a9715581146' = 'CH',
	'd339e31b-1681-4f23-a35c-47a93fe0f715' = 'MM',
	'2307b96c-5769-41d7-b2fc-fa5ab192010f' = 'MM',
	'1a3adea5-0131-4d84-8761-1eaacf5f21cf' = 'RO',
	'0a9d2c80-f6eb-455d-936c-4baa26691147' = 'RW',
	'805440dc-0fa7-47d7-9ba8-38abb71e648c' = 'UG',
	'd1c2aae7-9018-42f7-b6b3-927857dfed06' = 'RU',
	'1bae3d91-07fc-466e-a47d-5cbb377a1148' = 'US',
	'2cbf4ea2-180d-477f-b58e-6dcc488b1149' = 'ER',
	'3dd05fb3-291e-4880-869f-7edd599c1150' = 'US',
	'84972624-628c-4df0-8844-9fc9c8c2ede3' = 'WS',
	'b0bda389-db91-41fb-bf51-eac827209120' = 'SV',
	'3f74d69e-f520-4a9f-aaba-4399d7045401' = 'CF',
	'4ee170c4-3a2f-4991-97a0-8fee6aad1151' = 'IN',
	'5ff281d5-4b40-4aa2-a8b1-90ff7bbe1152' = 'NG',
	'58510e0e-8a91-4894-9507-1d6aa82091b1' = 'MX',
	'd82e7246-1869-469e-8eaf-5c76ab47cdc4' = 'PK',
	'600392e6-5c51-4bb3-b9c2-a1008ccf1153' = 'IN',
	'f5953cd8-a4bc-4a37-a160-ec24e4371694' = 'ZA',
	'd379eabd-903d-48c2-ad53-88a1a640923a' = 'RS',
	'8d45cfb2-04e9-421a-8d33-e2883e26b6d4' = 'RS',
	'e2ab72fb-934c-48cb-9709-9b2e77421aa5' = 'SN',
	'68efc339-241f-404f-a4ed-c830a8e61bb5' = 'MM',
	'eb14f886-59d3-4f54-a0ce-2fd7924c951b' = 'CN',
	'd257773d-e39c-4d2f-ac30-d4768fc31d64' = 'ZW',
	'7114a3f7-6d62-4cc4-cad3-b2119dd01154' = 'PK',
	'bf05229f-fd0c-40d4-8e88-9e4eb76fe97f' = 'CN',
	'8225b508-7e73-4dd5-8be4-c322aee11155' = 'ZA',
	'b9d0a5be-7364-4ff5-b30e-027861bbc526' = 'PK',
	'166eac2f-3d66-46aa-b86c-787ead06453b' = 'CN',
	'744ac087-0001-4b7d-9505-6c1fe090abbe' = 'LK',
	'9336c619-8f84-4ee6-9cf5-d433bff21156' = 'UZ',
	'b558e83b-a1a6-4008-be17-f655e1141158' = 'CA',
	'e958d10e-21ed-4d27-9fb1-842dc2e0a644' = 'SK',
	'77017eb2-6562-46ef-9452-4d4167e75475' = 'SI',
	'486886d7-1fa0-49e8-8fd2-212813261d94' = 'SI',
	'7ed0b841-ea42-4349-8ee2-8826ad0a8466' = 'SO',
	'0b8f33da-9c2a-4960-80c8-ec4a79951b16' = 'ML',
	'1ac72d98-baa1-4433-8101-deafcbca8251' = 'IQ',
	'c8690574-44c3-45bd-89a6-1689e9186c1a' = 'ES',
	'c669f94c-b2b7-4119-8f28-0766f2251159' = 'ET',
	'1e67fcce-81b6-476f-8705-ef0625ba5d66' = 'SD',
	'83a13e6c-6b47-421b-b7f0-45aa294f0343' = 'GQ',
	'6436c3cd-58c5-4798-9747-18d531465db5' = 'KE',
	'97824c98-bf7d-47b0-80bb-8ef01115e1fc' = 'ZA',
	'd2d3f9a7-4ac9-437c-9f0c-8c5902038eee' = 'SE',
	'7581c9bc-c7be-43dd-a224-ae6ab5a489cf' = 'PH',
	'd77b0a5d-c3c8-422a-9039-187704361160' = 'TJ',
	'397a9d64-455a-4057-87e9-aa631c50860f' = 'VN',
	'70ba7b2e-f903-4bb9-a527-95a0b7d505a4' = 'CN',
	'55598328-15d9-4ff3-a959-b755165f8b35' = 'TW',
	'1edd4822-6c12-4d9b-8716-07e50965318c' = 'SG',
	'e88c1b6e-d4d9-433b-a14a-298815471161' = 'MA',
	'f99d2c7f-e5ea-444c-b25b-3a9926581162' = 'MX',
	'35f5d2a6-ee48-447b-b6e1-db531a7bb719' = 'KZ',
	'0aae3d90-f6fb-455d-936c-4baa37691163' = 'PH',
	'1bbf4ea1-080c-466e-a47d-5cbb488a1164' = 'MM',
	'd6cf9fe4-1e94-4ad2-9cae-185955e5c7a5' = 'IN',
	'e07d09dd-24b4-40cf-949c-9e9789f603b4' = 'CN',
	'7a02b5ae-af25-4884-95fc-02ea88bc3ab1' = 'TH',
	'6faac626-b6eb-4656-b570-4dd043bd1091' = 'CN',
	'5c3b0363-e7f8-4709-b98b-c21f65434d93' = 'ER',
	'3de170c3-2a2e-4880-869f-7edd6aac1166' = 'US',
	'4ef281d4-3b3f-4991-97a0-8fee7bbd1167' = 'CN',
	'dca5dac3-f1b7-42ca-93ce-d848133e1d33' = 'CN',
	'9dabbf35-b41c-4992-923b-60e2fc86a01a' = 'CN',
	'eb095158-475d-4010-ab46-7415df730014' = 'TO',
	'5f0392e5-4c50-4aa2-a8b1-90008cce1168' = 'MX',
	'6014a3f6-5d61-4bb3-b9c2-a1119ddf1169' = 'FM',
	'2cd05fb2-191d-477f-b58e-6dcc599b1165' = 'NG',
	'd3e61ff7-44e7-4e52-acf6-d164aeb3877c' = 'GH',
	'c67b0a5c-b3c7-4119-8f28-077704351175' = 'BF',
	'4360f50d-f083-4d41-8798-9f69e0f4c833' = 'MX',
	'00854c98-840b-46eb-b912-5b5f2c645a34' = 'MX',
	'0e6f2a9b-9cca-4555-8101-4bf5f87525fa' = 'BW',
	'7125b507-6e72-4cc4-cad3-b222aef01170' = 'BW',
	'26b49298-684d-4743-9168-01251429d519' = 'KE',
	'c64fc4ab-0227-43b8-8df6-1d91b254f1cd' = 'TR',
	'a458e83a-91a5-4ff7-ad06-e555e1131173' = 'TM',
	'8236c618-7f83-4dd5-8be4-c333bff11171' = 'IN',
	'9347d729-8094-4ee6-9cf5-d444d0021172' = 'MW',
	'd78c1b6d-c4d8-422a-9039-188815461176' = 'SD',
	'f094a409-7c1e-41bb-8791-12072e4f438e' = 'UA',
	'e89d2c7e-d5e9-433b-a14a-299926571177' = 'CN',
	'c1f4b6aa-5d9e-4f71-8d3c-2e7a9b6f2201' = '',
	'38904043-0e65-4b20-82ee-df6f682f72de' = 'PK',
	'0abf4ea0-f70b-455d-936c-4bbb48891179' = 'SU',
	'4c855a3f-9cc1-4e70-ad88-5c05072f6b13' = 'UZ',
	'1bd05fb1-081c-466e-a47d-5ccc599a1180' = 'US',
	'0b81cb15-0c46-4d1a-9a68-abf46701b451' = 'ZA',
	'2736636d-ea4d-4e2b-bcb6-face84195958' = 'VN',
	'd3dd4292-31ee-4069-923a-e76d086300b1' = 'PH',
	'44a29cb2-b6d6-4b43-b595-b43dfc884fc8' = 'PH',
	'2ce170c2-192d-477f-b58e-6ddd6aab1181' = 'PH',
	'3df281d3-2a3e-4880-869f-7eee7bbc1182' = 'US',
	'a7d1b56c-4fe7-4d31-a726-8d21aa7ba42c' = 'GB-WLS',
	'4e0392e4-3b4f-4991-97a0-8fff8ccd1183' = 'ET',
	'f355ddc2-9147-407b-b086-469b35556784' = 'SN',
	'5c2c063f-d77e-4b9a-9efa-57fc54b39201' = 'ZA',
	'8148eea3-fb54-4acf-828e-0dd86e5cce13' = 'ZA',
	'5f14a3f5-4c60-4aa2-a8b1-90109dde1184' = 'US',
	'6025b506-5d71-4bb3-b9c2-a121aee01185' = 'RU',
	'7136c617-6e82-4cc4-cad3-b232bff11186' = 'MZ',
	'a61e2249-c7ae-4b14-908e-fd6ede093b10' = 'FM',
	'8247d728-7f93-4dd5-8be4-c343d0021187' = 'GW',
	'68d7385d-300f-4e20-8b12-6a15e8bfdb8d' = 'IL',
	'6b38fe92-1bc2-4b56-939f-77c769dc0e7d' = 'US',
	'0037aa8a-2610-4eb8-b8e5-331ca438fc93' = 'MX',
	'7876b1cf-9fa9-49f2-b725-51d12b464d14' = 'NG',
	'a469f94a-91b5-4ff7-ad06-e565f2241189' = 'GW',
	'b57b0a5b-a2c6-4008-be17-f67704351190' = 'TZ',
	'41ca517e-e282-4efe-a1ba-cc5e4c5163e6' = 'MM',
	'9668f20c-f941-444b-8472-83132d18834c' = 'MM',
	'cd9923d4-de2c-4739-9fd8-e273391d5c8b' = 'ZA',
}
